require("babel-polyfill");
import Vue from 'vue'
import Vuex from 'vuex'
// import parts from modules
import storeApp from './store-app'
import stateLocalStorage from './local-storage'
import plugins from './plugins'
// Make vue aware of Vuex
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        storeApp,
        stateLocalStorage,
    },
    plugins: plugins
})




// WEBPACK FOOTER //
// ./src/vuex/store.js